import { ReactNode } from "react";
import { StyleProp, ViewStyle } from "react-native";
import Animated, { useAnimatedStyle } from "react-native-reanimated";
import usePhotoDetailStore from "../../../stores/usePhotoDetailStore";

const MainPhotoItemZoomWrapper = ({
	children,
	style,
}: {
	children: ReactNode;
	style?: StyleProp<ViewStyle>;
}) => {
	const zoomScale = usePhotoDetailStore((state) => state.zoomScale);
	const zoomXOffset = usePhotoDetailStore((state) => state.zoomXOffset);
	const zoomYOffset = usePhotoDetailStore((state) => state.zoomYOffset);

	const animatedStyle = useAnimatedStyle(() => {
		return {
			transform: [
				{
					scale: zoomScale?.value ?? 1,
				},
				{
					translateX: zoomXOffset?.value ?? 0,
				},
				{
					translateY: zoomYOffset?.value ?? 0,
				},
			],
		};
	}, [zoomScale, zoomXOffset, zoomYOffset]);

	return (
		<Animated.View
			style={[
				animatedStyle,
				{
					width: "100%",
					height: "100%",
				},
				style,
			]}
		>
			{children}
		</Animated.View>
	);
};
export default MainPhotoItemZoomWrapper;
